// Orca Engine 4-Pane Layout Feature Flags
// 4-pane is the only production shell. Local development may use the legacy
// query for comparison without exposing that retired path to customers.

export function shouldUseOrcaEngine4Pane(
  search: string,
  production: boolean,
): boolean {
  if (production) return true;
  return new URLSearchParams(search).get('legacy') !== 'true';
}

export function removeLegacyQuery(search: string): string {
  const params = new URLSearchParams(search);
  params.delete('legacy');
  const serialized = params.toString();
  return serialized ? `?${serialized}` : '';
}

export const useOrcaEngine4Pane = (): boolean => {
  const production = Boolean((import.meta as any).env?.PROD);
  const search = window.location.search;

  if (production && new URLSearchParams(search).has('legacy')) {
    const nextSearch = removeLegacyQuery(search);
    window.history.replaceState(
      window.history.state,
      '',
      `${window.location.pathname}${nextSearch}${window.location.hash}`,
    );
  }

  return shouldUseOrcaEngine4Pane(search, production);
};

export const ORCA_ENGINE_CONFIG = {
  chatPaneRatio: 0.33,
  minChatWidth: 280,
  minUcsWidth: 300,
  splitterWidth: 6,
  sidebarWidth: 240,
  sidebarRail: 56,
} as const;
